import { render, staticRenderFns } from "./ScholarshipStatistics.vue?vue&type=template&id=601c02d0"
import script from "./ScholarshipStatistics.vue?vue&type=script&lang=js"
export * from "./ScholarshipStatistics.vue?vue&type=script&lang=js"
import style0 from "./ScholarshipStatistics.vue?vue&type=style&index=0&id=601c02d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports